module.exports = __webpack_public_path__ + "img/hr-heated-corner-down-left-6.2a4e69c0.png";